'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dIcon from "./io.intela.sites.intelacloud.content.-Icon.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Icon$$anon$2(\u03b4name$4, _$ordinal$4) {
  this.jT = null;
  this.jT = \u03b4name$4;
}
export { $c_Lio_intela_sites_intelacloud_content_Icon$$anon$2 as $c_Lio_intela_sites_intelacloud_content_Icon$$anon$2 };
$p = $c_Lio_intela_sites_intelacloud_content_Icon$$anon$2.prototype = new $j_io$002eintela$002esites$002eintelacloud$002econtent$002e$002dIcon.$h_Lio_intela_sites_intelacloud_content_Icon();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Icon$$anon$2;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Icon$$anon$2() {
}
export { $h_Lio_intela_sites_intelacloud_content_Icon$$anon$2 as $h_Lio_intela_sites_intelacloud_content_Icon$$anon$2 };
$h_Lio_intela_sites_intelacloud_content_Icon$$anon$2.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return this.jT;
});
$p.r = (function() {
  return this.jT;
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I(this.jT);
});
var $d_Lio_intela_sites_intelacloud_content_Icon$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Icon$$anon$2, "io.intela.sites.intelacloud.content.Icon$$anon$2", ({
  eQ: 1,
  eO: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1,
  ah: 1,
  U: 1,
  af: 1,
  ag: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Icon$$anon$2 as $d_Lio_intela_sites_intelacloud_content_Icon$$anon$2 };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Icon$$anon$2.js.map
